import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Divider, Tooltip } from "@mui/material";
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import MainDrawer from "Drawers/MainDrawer";
import theme from "Helpers/theme";
import conectadoIcon from "img/ConectadoIcon.png";
import * as React from "react";
import { Link, useSearchParams } from "react-router-dom";
import Cookies from "universal-cookie";
import AppIcon from "Helpers/AppIcon";
import APIRequest from "Helpers/ApiRequest.js";
import { ScopeMap } from "Helpers/Scopes";
import VirtualizedList from "Helpers/VirtList";
import { useSnackbar } from "notistack";
import useMediaQuery from "@mui/material/useMediaQuery";

const defaultTheme = theme;

const cookies = new Cookies();

function Capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default function SignUp(props) {
  const [err, setErrorSignup] = React.useState("");
  const [mess, setMessageSignup] = React.useState("Unknown Error");
  const [searchParams, setSearchParams] = useSearchParams();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [firstname, setFirstname] = React.useState("");
  const [lastname, setLastname] = React.useState("");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [verified, setVerified] = React.useState(false);
  const [remember, setRemember] = React.useState(false);
  const [pageType, setPageType] = React.useState("register");
  const areAllFieldsFilled =
    email != "" && password != "" && lastname != "" && firstname != "";
  const [requestedActions, setRequestedActions] = React.useState();
  const params = Object.fromEntries([...searchParams]);
  const isMobile = useMediaQuery(theme.breakpoints.up("sm"));
  const [isOAuth, setIsOAuth] = React.useState(
    Object.fromEntries([...searchParams])["client_id"]
  );
  const [oAuthValid, setOAuthValid] = React.useState(false);
  const [showInvalidOAuth, setShowInvalidOAuth] = React.useState(false);
  const [showMain, setShowMain] = React.useState(true);
  const [oAuthOpen, setOAuthOpen] = React.useState(false);
  const [oAuthDetails, setOAuthDetails] = React.useState({
    name: "",
    email: "",
    website: "",
  });
  const scopeMap = ScopeMap;

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleVerified = async (event) => {
    event.preventDefault();
    var body = await APIRequest({ action: "password_forget", email: email });

    setForgotOpen(false);
  };

  React.useEffect(() => {
    if (localStorage.getItem("remember")) {
      setRemember(localStorage.getItem("remember") === "true" ? true : false);
    }

    if (searchParams.get("test")) {
      if (searchParams.get("test") === "verify") {
        handleOpen();
        setShowMain(false);
      }
    }
    if (Object.fromEntries([...searchParams])["client_id"]) {
      if (
        Object.fromEntries([...searchParams])["client_id"] ===
        "2heZb6TYHzb9ksq6ChepVZunbTCkbBd4"
      ) {
        setPageType("backpack");
      } else {
        setPageType("oauth");
      }
    }

    const handleOAuth = async () => {
      if (!searchParams.get("client_id")) {
        setShowInvalidOAuth(false);
      }
      if (
        params["oauth2"] == 1 &&
        params["client_id"] &&
        params["scope"] &&
        params["state"] &&
        params["response_type"]
      ) {
        var oAuthReq = await APIRequest({
          action: "oauth2_get_client_info",
          client_id: params["client_id"],
          scope: params["scope"],
          state: params["state"],
          response_type: params["response_type"],
          ...(params["redirect_uri"]
            ? { redirect_uri: params["redirect_uri"] }
            : {}),
        });
        if (oAuthReq.status == true) {
          setOAuthDetails({
            name: oAuthReq.data.name.replaceAll("_", " "),
            email: oAuthReq.data.contact_email,
            website: oAuthReq.data.website,
          });
          var scopes = params["scope"].split(" ");
          var scopesList = [];
          scopes.forEach((x) =>
            scopeMap[x]
              ? scopesList.push({
                  title: Capitalize(x),
                  data: scopeMap[x].data,
                  icon: scopeMap[x].icon,
                })
              : scopesList.push({
                  title: Capitalize(x),
                  data: "",
                  icon: "star",
                })
          );
          setRequestedActions(scopesList);
          setOAuthValid(true);
          handleOAuthOpen();
        } else {
          enqueueSnackbar(oAuthReq.message, {
            variant: "error",
            preventDuplicate: true,
          });
          setOAuthValid(false);
          setShowInvalidOAuth(true);
          handleOAuthClose();
        }
      }
    };
    handleOAuth();
    if (localStorage.getItem("remember") === "true") {
      if (localStorage.getItem("email")) {
        setEmail(localStorage.getItem("email"));
      }
    }
  }, []);

  const handleOAuthOpen = () => {
    setOAuthOpen(true);
  };

  const handleOAuthClose = () => {
    setOAuthOpen(false);
  };

  var loc = searchParams.get("plc") ? "/?plc=" + searchParams.get("plc") : "";
  var loc2 = window.location.search;
  var plc2 = "";
  if (searchParams.get("plc")) {
    plc2 = searchParams.get("plc");
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    var body = await APIRequest({
      action: "register",
      firstname: data.get("firstname"),
      lastname: data.get("lastname"),
      email: data.get("email"),
      password: data.get("password"),
      ...(params["plc"] ? { external_login: params["plc"] } : {}),
      ...(oAuthValid
        ? {
            client_id: params["client_id"],
            scope: params["scope"],
            state: params["state"],
            response_type: params["response_type"],
          }
        : {}),
      ...(params["redirect_uri"]
        ? { redirect_uri: params["redirect_uri"] }
        : {}),
    });

    if (body.status == true) {
      var userID = body.data.account_id;
      var cookieID = body.data.cookie_id;
      var firstName = data.get("firstname");
      var lastName = data.get("lastname");
      cookies.set("user", userID, { path: "/", secure: true, sameSite: "Lax" });
      cookies.set("cookie", cookieID, {
        path: "/",
        secure: true,
        sameSite: "Lax",
      });
      cookies.set("firstname", firstName, {
        path: "/",
        secure: true,
        sameSite: "Lax",
      });
      cookies.set("lastname", lastName, {
        path: "/",
        secure: true,
        sameSite: "Lax",
      });

      if (body.data.auth_code && body.data.redirect_uri) {
        enqueueSnackbar(`Successfully Linked Account`, { variant: "success" });
        window.location.replace(body.data.redirect_uri);
      } else {
        setErrorSignup("success");
        handleOpen();
        enqueueSnackbar(
          `Registration Successful${
            params["plc"]
              ? params["plc"].length > 0
                ? ", Continue On Client"
                : ", Sending To Conectado"
              : ""
          }`,
          { variant: "success" }
        );
      }
    } else {
      setErrorSignup("error");
      enqueueSnackbar(body.message, {
        variant: "error",
        preventDuplicate: true,
      });
    }
  };

  return (
    <Box id="Main Container">
      {pageType !== "backpack" && <MainDrawer />}

      {!showInvalidOAuth && (
        <Container component="main" maxWidth="xs" id="Register Container">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ...(pageType === "backpack"
                ? { marginTop: "3rem" }
                : {}),
            }}
            id="Register Box"
          >
            <AppIcon />
            {pageType === "register" && (
              <Typography
                component="h1"
                variant="h5"
                sx={{
                  textAlign: "center",
                  ...(oAuthDetails?.website
                    ? { marginBottom: "0px" }
                    : { marginBottom: "1rem" }),
                }}
              >
                Register for Conectado
              </Typography>
            )}
            {pageType === "backpack" && (
              <div>
                <Typography
                  component="h1"
                  variant="h5"
                  sx={{
                    textAlign: "center",
                    ...(oAuthDetails?.website
                      ? { marginBottom: "0px" }
                      : { marginBottom: "1rem" }),
                  }}
                >
                  Join the Conectado Ecosystem
                </Typography>
                <Typography
                  component="h2"
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    marginBottom: "0.5rem",
                    fontSize: "0.8rem",
                  }}
                >
                  Access the AI Opportunity Backpack and the Conectadoverse
                </Typography>
              </div>
            )}
            {pageType === "oauth" && (
              <div>
                {oAuthDetails?.website && (
                  <Typography
                    component="h1"
                    variant="h5"
                    sx={{
                      textAlign: "center",
                    }}
                  >
                    Join the Conectado Ecosystem
                  </Typography>
                )}
                {oAuthDetails?.website && (
                  <Typography
                    component="h2"
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      ...(oAuthDetails?.website
                        ? { marginBottom: "0px" }
                        : { marginBottom: "1rem" }),
                    }}
                  >
                    {`Authori${
                      (navigator?.language || navigator?.userLanguage) ===
                      "en-GB"
                        ? "s"
                        : "z"
                    }ation Request`}
                  </Typography>
                )}
                {oAuthDetails?.name && (
                  <Tooltip
                    arrow
                    describeChild
                    title={
                      oAuthDetails?.email && (
                        <React.Fragment>
                          <Typography
                            color="inherit"
                            sx={{ fontWeight: 700, fontSize: 12 }}
                          >
                            Contact
                          </Typography>
                          <Typography
                            component={Link}
                            to={`mailto:` + oAuthDetails?.email}
                            target="_blank"
                            rel="noopener noreferrer"
                            color="inherit"
                            sx={{ textDecoration: "none", fontSize: 14 }}
                          >
                            {oAuthDetails?.email}
                          </Typography>
                        </React.Fragment>
                      )
                    }
                  >
                    <Typography
                      component={oAuthDetails?.website ? Link : "h1"}
                      to={oAuthDetails?.website}

                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textAlign: "center",
                        textDecoration: "none",
                        fontSize: "11px",
                        color: "text.secondary",
                        textAlign: "center",
                      }}
                    >
                      {oAuthDetails?.name} is requesting access to your
                      Conectado account
                    </Typography>
                  </Tooltip>
                )}
                {oAuthValid && (
                  <VirtualizedList
                    width={"100%"}
                    height={200}
                    itemSize={80}
                    items={requestedActions}
                  />
                )}
              </div>
            )}

            <Box
              component="form"
              id="loginForm"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1, width: "100%" }}
            >
              <Typography component="h3" variant="h6">
                Email
              </Typography>
              <TextField
                margin="none"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                autoFocus
                variant="filled"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    borderRadius: "15px",
                    "& input": { paddingLeft: 2 },
                    "& .MuiFilledInput-input:autofill": {
                      boxShadow: 0,
                      borderRadius: 0,
                    },
                  },
                }}
              />
              <Typography
                component="h3"
                variant="h6"
                sx={{ marginTop: "1rem" }}
              >
                Password
              </Typography>
              <TextField
                margin="none"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                variant="filled"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    borderRadius: "15px",
                    "& input": { paddingLeft: 2 },
                    "& .MuiFilledInput-input:autofill": {
                      boxShadow: 0,
                      borderRadius: 0,
                    },
                  },
                }}
              />

              <Grid
                container
                alignItems="center"
                justifyContent="center"
                sx={{}}
              >
                <Grid item xs>
                  <Typography
                    component="h3"
                    variant="h6"
                    sx={{ marginTop: "1rem" }}
                  >
                    First Name
                  </Typography>
                  <TextField
                    margin="none"
                    required
                    fullWidth
                    name="firstname"
                    label="First Name"
                    id="firstname"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    autoComplete="current-firstname"
                    variant="filled"
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        borderRadius: "15px",
                        "& input": { paddingLeft: 2 },
                        "& .MuiFilledInput-input:autofill": {
                          boxShadow: 0,
                          borderRadius: "inherit",
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs sx={{ marginLeft: "1rem" }}>
                  <Typography
                    component="h3"
                    variant="h6"
                    sx={{ marginTop: "1rem" }}
                  >
                    Last Name
                  </Typography>
                  <TextField
                    margin="none"
                    required
                    fullWidth
                    name="lastname"
                    label="Last Name"
                    id="lastname"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    autoComplete="current-lastname"
                    variant="filled"
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        borderRadius: "15px",
                        "& input": { paddingLeft: 2 },
                        "& .MuiFilledInput-input:autofill": {
                          boxShadow: 0,
                          borderRadius: 0,
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Divider sx={{ marginTop: "1rem" }}></Divider>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={!areAllFieldsFilled}
                endIcon={<ArrowForwardIcon />}
                sx={{ mt: 3, mb: 2 }}
              >
                {oAuthValid && pageType === "oauth"
                  ? "Register And Link"
                  : "Register"}
              </Button>
              <Typography
                variant="body2"
                textAlign="center"
                sx={{
                  color: "text.secondary",
                  align: "center",
                  fontWeight: 600,
                }}
              >
                Already have an account?{" "}
                {
                  <Typography
                    component={Link}
                    to={`/login${loc2}`}
                    variant="contained"
                    color="primary"
                    sx={{ textDecoration: "none" }}
                  >
                    Login
                  </Typography>
                }
              </Typography>
            </Box>
          </Box>
        </Container>
      )}
      {showInvalidOAuth && (
        <Container component="main" maxWidth="xs" id="Invalid OAuth">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AppIcon />
            <Typography
              component="h1"
              variant="h5"
              sx={{
                textAlign: "center",
                ...(oAuthDetails?.website
                  ? { marginBottom: "0px" }
                  : { marginBottom: "1rem" }),
              }}
            >
              You have been incorrectly directed to this page
            </Typography>
          </Box>
        </Container>
      )}
      <Container component="main" maxWidth="xs" id="Verification Container">
        <CssBaseline />
        <Backdrop
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            bgcolor: isMobile ? "#0000007c" : "background.paper",
            backdropFilter: isMobile ? "blur(5px)" : "none",
          }}
          open={open}
          // onClick={handleClose}
          id="Verification Backdrop"
        >
          <Box
            sx={{
              width: 500,
              height: 700,
              borderRadius: 8,
              bgcolor: "background.paper",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderColor: "background.paper",
            }}
            id="Verification Box"
          >
            <AppIcon />
            <Typography
              variant="h4"
              fontWeight={800}
              sx={{
                marginBottom: ".5rem",
                color: "main",
                maxWidth: "80%",
                textAlign: "center",
              }}
            >
              Welcome {firstname}
            </Typography>
            <Typography
              variant="h5"
              fontWeight={800}
              noWrap
              sx={{
                marginBottom: "2rem",
                color: "main",
                maxWidth: "80%",
                textAlign: "center",
                textWrap: "pretty",
                textOverflow: "ellipsis",
              }}
            >
              An email has been sent to <br />
              {email}
            </Typography>
            <Typography
              variant="h5"
              fontWeight={800}
              sx={{
                color: "main",
                maxWidth: "80%",
                textAlign: "center",
                textWrap: "pretty",
                textOverflow: "ellipsis",
              }}
            >
              {!isOAuth
                ? "Please verify your email address to access Conectado"
                : ""}
              {isOAuth &&
                "Please follow the instructions sent to your email to access"}
            </Typography>
            {isOAuth && (
              <Typography
                component={Link}
                to={oAuthDetails.website}
                variant="h5"
                fontWeight={800}
                color={"primary"}
              >
                {oAuthDetails?.name}
              </Typography>
            )}
            {!isOAuth && (
              <Button
                variant="contained"
                sx={{ margin: "1rem" }}
                href={`/login${loc2}`}
              >
                Already Verified?
              </Button>
            )}
            {plc2.length > 0 && (
              <Typography
                variant="h5"
                fontWeight={500}
                sx={{ marginBottom: "1rem", color: "main" }}
              >
                Please Continue On Client
              </Typography>
            )}
          </Box>

          {/* <Snackbar open={err != ""} autoHideDuration={6000}>
          <Alert severity={err == "" ? "error" : err} sx={{ width: "100%" }}>
            {mess}
          </Alert>
        </Snackbar> */}
        </Backdrop>
      </Container>

      {/* <Snackbar open={err != "" && !open} autoHideDuration={6000}>
        <Alert severity={err == "" ? "error" : err} sx={{ width: "100%" }}>
          {mess}
        </Alert>
      </Snackbar> */}
    </Box>
  );
}
